import React from 'react';
import {useRef, useEffect, useState} from 'react';
import axios from 'axios';

function AddDevice(type) {
    const [deviceData, setDeviceData] = useState(null);
    const [testPassed, setTestPassed] = useState(null);

    const ref = useRef(null);
    const ref1 = useRef(null);
    
    // Sends the device data to the backend to be stored in DB
    const addDevice = async () => {
        try {
            const deviceAdded = await axios({
                url: `${import.meta.env.VITE_DEVBACKENDPATH}:${import.meta.env.VITE_BACKENDPORT}/api/devicedata/add`,
                method: "POST",
                data: deviceData
            });

            if(deviceAdded.status === 200) {
                console.log('Successfully added device to your account');
                alert("Successfully Added device to your account!");
            } else {
                console.log("Failed to add device to your account");
                alert("Failed to add device to your account");
            }
        } catch(err) {
            console.log(err);
        }
   }


    useEffect(() => {
        const getCookie = (name) => {
            const match = document.cookie
              .split("; ")
              .find((row) => row.startsWith(name + "="));
          
            if (!match) return null; // Return null if cookie not found
      
            try {
              const rawValue = match.split("=")[1];
            //   console.log(`Raw cookie value for ${name}:`, rawValue);
              return decodeURIComponent(rawValue); // Properly decode it
            } catch (error) {
              console.error(`Error decoding cookie ${name}:`, error);
              return null; // Return null if decoding fails
            }
        }
        // Grabbing needed cookies
        const loginToken = getCookie('data');
        const email = document.cookie.split(";")[2].split("=")[1];

        // Test Connection of Device
       const handleSubmit = async (event) => {
            event.preventDefault();

            const {hostname, ipaddress, password, domain, portba, portrdp} = event.target;
            const statusPath = '/api/status';
            const testUrl = `https://${ipaddress.value}:${portba.value}${statusPath}`;
            try {
                const isOnline = await axios({
                    url: testUrl, 
                    method: 'GET',
                });
                
                if(isOnline.status === 200) {
                    setTestPassed("Passed!");
                    document.getElementById("testresponse").className = "ps-3 text-success";

                    // If test is successful store the device data
                    setDeviceData({
                        remoteAddress: ipaddress.value,
                        domainName: domain.value,
                        password: password.value,
                        hostname: hostname.value,
                        port: portba.value,
                        portRemote: portrdp.value,
                        deviceType: type.type,
                        loginToken: loginToken,
                        email: email
                    });
                } else {
                    setTestPassed("Failed");
                    document.getElementById("testresponse").className = "ps-3 text-danger";
                }
            } catch (err) {
                console.log(err);
                setTestPassed("Failed");
                document.getElementById("testresponse").className = "ps-3 text-danger";
            }
       };

       const element = ref.current;

       element.addEventListener('submit', handleSubmit);
    
        return () => {
            element.removeEventListener('submit', handleSubmit);
        };

    },[]);

    if(type.type === "computer") {
        return (
            <article className='Dashboard d-flex flex-column justify-content-center align-items-center bg-black text-white p-4'>
                {/* <section className='myDevices d-flex flex-column p-5'> */}
                <h1 className='mb-5 mt-3'>Add Computer</h1>
                <section className='myDevices d-flex flex-column p-5 bg-black text-white border rounded-3'>
                    {/* <iframe className='border' style={{height: screen.height, width: screen.width/1.5}} src='http://ec2-3-237-60-183.compute-1.amazonaws.com:3000/?apikey=qazwsxedcrfvvfrcdexswzaq' title='computer'></iframe> */}
                    <form id="addCompForm" className='row' ref={ref} action="" rel="external" method="get">
                        <div id='hostnamefield' className='mb-3'>
                            <label htmlFor="hostname" className='form-label fs-4'>Hostname:</label>
                            <input id="hostname" className='form-control bg-black text-white' name='hostname' type="text" autoComplete='text' placeholder='hostname...' required autoFocus/>
                        </div>
                        <div id='passfield' className='mb-3'>
                            <label htmlFor="password" className='form-label fs-4'>Device Password:</label>
                            <input id="password" className='form-control bg-black text-white' name="password" type="password" autoComplete='password' placeholder='password...' required/>
                        </div>
                        <div id='ipaddressfield' className='mb-3'>
                            <label htmlFor="ipaddress" className='form-label fs-4'>Public IPv4 Address:</label>
                            <input id="ipaddress" className='form-control bg-black text-white' name="ipaddress" type="text" autoComplete='ipaddress' placeholder='ex: 197.1.23.442' required/>
                        </div>
                        <div id='domainfield' className='mb-3'>
                            <label htmlFor="domain" className='form-label fs-4'>Domain Name:</label>
                            <input id="domain" className='form-control bg-black text-white' name="domain" type="text" autoComplete='domain' placeholder='http://www.example.com' />
                        </div>
                        <div id='portbafield' className='mb-3'>
                            <label htmlFor="portba" className='form-label fs-4'>Backdoor-API Port:</label>
                            <input id="portbafield" className='form-control bg-black text-white' name="portba" type="text" autoComplete='portba' placeholder='ex: 3333' required/>
                        </div>
                        <div id='portrdpfield' className='mb-3'>
                            <label htmlFor="portrdp" className='form-label fs-4'>Remote Ctrl Port:</label>
                            <input id="portrdp" className='form-control bg-black text-white' name="portrdp" type="text" autoComplete='portrdp' placeholder='ex: 3000' required/>
                        </div>
                        <div className='mb-3'>
                            <button type="submit" className='btn btn-primary'>Test Connection</button>
                            <span id='testresponse' className='ps-3'><b>{testPassed}</b></span>
                        </div>
                    </form>
                    { testPassed === "Passed!" ?
                        <div className='mb-3'>
                            <button id='addBtn' type="button" ref={ref1} onClick={addDevice} className='btn btn-success'>Add</button>
                        </div> 
                        :
                        <div className='mb-3'>
                        </div>
                    }
                </section>
                {/* </section> */}
            </article>
        );
    } else {
        return (
            <article className='Dashboard d-flex flex-column justify-content-center align-items-center bg-light p-4 mt-1 mb-5 border border-light rounded-3'>
                {/* <section className='myDevices d-flex flex-column p-5'> */}
                <h1 className='mb-5'>Add IoT Device</h1>
                <section className='myDevices d-flex flex-column p-5 bg-white border rounded-3'>
                    {/* <iframe className='border' style={{height: screen.height, width: screen.width/1.5}} src='http://ec2-3-237-60-183.compute-1.amazonaws.com:3000/?apikey=qazwsxedcrfvvfrcdexswzaq' title='computer'></iframe> */}
                    <form id="addCompForm" className='row' ref={ref} action="" rel="external" method="get">
                        <div id='hostnamefield' className='mb-3'>
                            <label htmlFor="hostname" className='form-label'>Hostname:</label>
                            <input id="hostname" className='form-control' name='hostname' type="text" autoComplete='text' placeholder='hostname...' required autoFocus/>
                        </div>
                        <div id='passfield' className='mb-3'>
                            <label htmlFor="password" className='form-label'>Device Password:</label>
                            <input id="password" className='form-control' name="password" type="password" autoComplete='password' placeholder='password...' required/>
                        </div>
                        <div id='ipaddressfield' className='mb-3'>
                            <label htmlFor="ipaddress" className='form-label'>Public IPv4 Address:</label>
                            <input id="ipaddress" className='form-control' name="ipaddress" type="text" autoComplete='ipaddress' placeholder='ex: 197.1.23.442' required/>
                        </div>
                        <div id='domainfield' className='mb-3'>
                            <label htmlFor="domain" className='form-label'>Domain Name:</label>
                            <input id="domain" className='form-control' name="domain" type="text" autoComplete='domain' placeholder='http://www.example.com' />
                        </div>
                        <div id='portbafield' className='mb-3'>
                            <label htmlFor="portba" className='form-label'>Backdoor-Agent Port:</label>
                            <input id="portbafield" className='form-control' name="portba" type="text" autoComplete='portba' placeholder='ex: 4444' required/>
                        </div>
                        <div className='mb-3'>
                            <button type="submit" className='btn btn-primary'>Test Connection</button>
                            <span id='testresponse' className='ps-3'><b>{testPassed}</b></span>
                        </div>
                    </form>
                    { testPassed === "Passed!" ?
                        <div className='mb-3'>
                            <button id='addBtn' type="button" ref={ref1} onClick={addDevice} className='btn btn-success'>Add</button>
                        </div> 
                        :
                        <div className='mb-3'>
                        </div>
                    }
                </section>
                {/* </section> */}
            </article>
        );
    }

}

export default AddDevice;